import {
  OutsideTemperatures,
  PayloadPeopleValues,
  RangeEnvironmentsPrivate,
  RangeSimRimId,
  RangeTrimModel,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import React from 'react';
import {calculateRange} from './calculate-range';
import {YesNoValues} from '../components/yes-no-toggle';
import {DrivingProfileVector} from '../utils/get-default-driving-profile';

export function useRangeCalculation(
  selectedModel: RangeTrimModel,
  formState: {
    rim: RangeSimRimId;
    payloadPeople: PayloadPeopleValues;
    payloadWeight: number | string;
    drivingProfile: DrivingProfileVector;
    outsideTemperature: OutsideTemperatures;
    airConditioning: YesNoValues;
    fasterHighway: YesNoValues;
  }
): number {
  return React.useMemo(() => {
    const {
      rim,
      payloadPeople,
      payloadWeight,
      drivingProfile,
      outsideTemperature,
      airConditioning,
      fasterHighway,
    } = formState;
    const selectedRim = selectedModel.simulationConstants.rims[rim];
    if (!selectedRim) {
      throw new Error("Did not find state's rim id inside selectedModel.rims");
    }

    /* Markets that don't specify payloadUi in their tenant configuration
        (e.g. Audi) are using toggle by default */
    const payload =
      selectedModel.simulationConstants.payloadUi?.kind === 'slider'
        ? typeof payloadWeight === 'string'
          ? Number(payloadWeight)
          : payloadWeight
        : payloadPeople === PayloadPeopleValues.multiple;

    return calculateRange(
      {
        [RangeEnvironmentsPrivate.city]: drivingProfile[0] / 100,
        [RangeEnvironmentsPrivate.country]: drivingProfile[1] / 100,
        [RangeEnvironmentsPrivate.motorway]: drivingProfile[2] / 100,
        // motorwayPlus needs the same proportion as motorway, to include the "faster highway" toggle
        [RangeEnvironmentsPrivate.motorwayPlus]: drivingProfile[2] / 100,
      },
      outsideTemperature,
      airConditioning === YesNoValues.yes,
      fasterHighway === YesNoValues.yes,
      payload,
      selectedRim,
      selectedModel.simulationConstants
    );
  }, [formState, selectedModel]);
}
